module.exports = __webpack_public_path__ + "static/media/cellfind.76476f42.png";